import React, {
  useState,
  useRef,
  memo,
  useMemo,
  useEffect,
} from "react";
import { SketchPicker } from "react-color";

import leftAlign from "../../../../../assets/images/formatter/left-align.svg";
import rightAlign from "../../../../../assets/images/formatter/right-align.svg";
import justify from "../../../../../assets/images/formatter/justify.svg";

import "./formatter.styles.css";
import useToggle from "../../../../../components/useToggle";

const Formatter = ({
  getBackgroundColor,
  getFontColor,
  getTextAlignment,
  getTextStyle,
  getHeadingStyle,
  onHandledelete,
  toggleLock,
  isDraggable,
}) => {
  const [state, setstate] = useState({
    bg: {
      color: "#fff",
      isActive: false,
    },
    fill: {
      color: "#fff",
      isActive: false,
    },
    options: false,
  });

  const [headingFormat, setHeadingFormat] = useState({
    selected: "H1",
    options: [
      {
        type: "H1",
        size: 48,
      },
      {
        type: "H2",
        size: 32,
      },
      {
        type: "H3",
        size: 24,
      },
      {
        type: "H4",
        size: 16,
      },
    ],
    isActive: false,
  });
  const [headingActive, setHeadingActive] = useState(false);
  const [textFormat, setTextFormat] = useState({ bold: false, italics: false });
  const [isTextAlignmentActive, setTextAlignmentActive] = useState(false);
  const [textAlignment, setTextAlignment] = useState({
    textAlignType: "left",
    options: [
      {
        id: 1,
        type: "left",
        img: leftAlign,
      },
      {
        id: 2,
        type: "right",
        img: rightAlign,
      },
      {
        id: 3,
        type: "justify",
        img: justify,
      },
    ],
  });

  const toggleBgColorPicker = (type) => {
    setstate({
      ...state,
      bg: {
        ...state.bg,
        isActive: !state.bg.isActive,
      },
    });
  };

  const toggleFillColorPicker = () => {
    setstate({
      ...state,
      fill: {
        ...state.fill,
        isActive: !state.fill.isActive,
      },
    });
  };

  const bgRef = useRef(null);
  const fillRef = useRef(null);
  const optionsRef = useRef(null);
  const headingRef = useRef(null);
  const moreOptions = useRef(null);

  // const selectedHeading = useRef("H1");

  useToggle(bgRef, state.bg.isActive, toggleBgColorPicker);
  useToggle(fillRef, state.fill.isActive, toggleFillColorPicker);
  useToggle(optionsRef, isTextAlignmentActive, setTextAlignmentActive);
  useToggle(headingRef, headingActive, setHeadingActive);
  useToggle(moreOptions, state.options, () =>
    setstate({ ...state, options: false })
  );

  const toggleAlignment = () => {
    setTextAlignmentActive(!isTextAlignmentActive);
  };
  const changeTextAlignment = (type) => {
    console.log("i am the alignment type", type);
    setTextAlignment({
      ...textAlignment,
      textAlignType: type,
    });
    getTextAlignment(type);
  };

  const changeTextFormat = (type) => {
    setTextFormat({
      ...textFormat,
      [type]: !textFormat[type],
    });

    const format = {
      ...textFormat,
      [type]: !textFormat[type],
    };
    getTextStyle(format);
  };

  const selectedHeading = useMemo(() => headingFormat.selected, [
    headingFormat.selected,
  ]);

  const onChangeHeading = (option) => {
    const mutatedState = { ...headingFormat };
    mutatedState.selected = option.type;
    setHeadingFormat(mutatedState);

    console.log("the heading type selected", option.type);
    // setHeadingFormat({
    //   ...headingFormat,
    //   isActive: !headingFormat.isActive,
    //   selected: option.type,
    // });
    console.log({ mutatedState });
    getHeadingStyle(option);
  };

  const toggleheader = () => {
    setHeadingActive(!headingActive);
  };

  const handleChangeComplete = (color) => {
    setstate({
      ...state,
      bg: { ...state.bg, color: color.hex, isActive: false },
    });
    getBackgroundColor(color);
  };

  const handleChangeFontColor = (color) => {
    console.log({ color });
    setstate({
      ...state,
      fill: {
        ...state.fill,
        color: color.hex,
        isActive: false,
      },
    });
    getFontColor(color);
  };

  const setArrangementState = () => {
    setstate({
      ...state,
      options: !state.options,
    });
  };

  useEffect(() => {
    console.log({ headingFormat });
  }, [headingFormat]);

  const onHandleToggle = () => {
    setstate({
      ...state,
      options: !state.options,
    });
    toggleLock();
  };

  return (
    <div className="formatter__wrapper text--formatter">
      <div className="formatter__optionsWrapper">
        <div className="options" ref={bgRef}>
          <h6>Fill</h6>

          <div
            className="selected--color"
            style={{ backgroundColor: state.bg.color }}
            onClick={toggleBgColorPicker}
          ></div>
        </div>
        <div className="options" ref={fillRef}>
          <h6>Text color</h6>
          <div
            className="selected--color"
            style={{ backgroundColor: state.fill.color }}
            onClick={toggleFillColorPicker}
          ></div>
        </div>
        <div
          className={headingActive ? "options active-option-state" : "options"}
          onClick={toggleheader}
          ref={headingRef}
        >
          <h6>
            {headingFormat.selected}{" "}
            <span>
              <svg
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683418 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893Z"
                  fill="#0D0D0D"
                />
              </svg>
            </span>
          </h6>
          <div
            className={
              headingActive
                ? "options__dropdown heading-style show"
                : "options__dropdown"
            }
          >
            {headingFormat.options.map((option) => {
              return (
                <div
                  className={
                    selectedHeading === option.type
                      ? "options__dropdown--listItem flex-start selected-heading"
                      : "options__dropdown--listItem flex-start"
                  }
                  key={option.type}
                  onClick={() => onChangeHeading(option)}
                >
                  <h1>{option.type}</h1>
                </div>
              );
            })}
          </div>
        </div>
        <div className={textFormat.bold ? "options selected" : "options"}>
          <div className="bold" onClick={() => changeTextFormat("bold")}>
            <svg
              width="10"
              height="14"
              viewBox="0 0 10 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.95363 0.699219C7.05763 0.699219 7.95162 1.00522 8.63562 1.61722C9.31963 2.21722 9.66163 3.02722 9.66163 4.04722C9.66163 4.87522 9.45763 5.51122 9.04963 5.95522C8.65363 6.38722 8.17362 6.68722 7.60963 6.85522V7.03522C8.18563 7.19122 8.68363 7.49722 9.10363 7.95322C9.52363 8.39722 9.73363 9.03922 9.73363 9.87922C9.73363 10.9232 9.38563 11.7572 8.68963 12.3812C8.00563 12.9932 7.11763 13.2992 6.02563 13.2992H0.265625V0.699219H5.95363ZM5.70163 5.88322C6.20563 5.88322 6.61363 5.75122 6.92563 5.48722C7.23763 5.21122 7.39363 4.83922 7.39363 4.37122C7.39363 3.90322 7.23763 3.53722 6.92563 3.27322C6.61363 2.99722 6.20563 2.85922 5.70163 2.85922H2.64163V5.88322H5.70163ZM5.73763 11.1392C6.26562 11.1392 6.68563 11.0012 6.99763 10.7252C7.30963 10.4492 7.46563 10.0712 7.46563 9.59122C7.46563 9.11122 7.30963 8.73322 6.99763 8.45722C6.68563 8.18122 6.26562 8.04322 5.73763 8.04322H2.64163V11.1392H5.73763Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        <div className={textFormat.italics ? "options selected" : "options"}>
          <div className="italics" onClick={() => changeTextFormat("italics")}>
            <svg
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.4904 0.457031H11.4904L10.7789 2.32619H8.77888L5.22128 11.672H7.22128L6.50977 13.5411H0.509766L1.22128 11.672H3.22128L6.77888 2.32619H4.77888L5.4904 0.457031Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        <div
          className={
            isTextAlignmentActive ? "options active-option-state" : "options"
          }
          onClick={toggleAlignment}
          ref={optionsRef}
        >
          <div className="text-align">
            {textAlignment?.options?.map((option) => {
              if (option.type === textAlignment.textAlignType) {
                return <img src={option.img} alt={option.type} />;
              }
            })}
          </div>
          <div
            className={
              isTextAlignmentActive
                ? "options__dropdown show"
                : "options__dropdown"
            }
          >
            {textAlignment?.options?.map((option) => {
              return (
                <div
                  className={
                    textAlignment.textAlignType !== option.type
                      ? "options__dropdown--listItem"
                      : "options__dropdown--listItem active"
                  }
                  onClick={() => changeTextAlignment(option.type)}
                  key={option.id}
                >
                  <img src={option.img} alt={option.type} />
                </div>
              );
            })}
          </div>
        </div>
        <div className="more--options" ref={moreOptions}>
          <div className="" onClick={setArrangementState}>
            <span>
              <svg
                width="16"
                height="4"
                viewBox="0 0 16 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 4C9.10457 4 10 3.10457 10 2C10 0.89543 9.10457 0 8 0C6.89543 0 6 0.89543 6 2C6 3.10457 6.89543 4 8 4Z"
                  fill="#C7C8C9"
                />
                <path
                  d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
                  fill="#C7C8C9"
                />
                <path
                  d="M14 4C15.1046 4 16 3.10457 16 2C16 0.89543 15.1046 0 14 0C12.8954 0 12 0.89543 12 2C12 3.10457 12.8954 4 14 4Z"
                  fill="#C7C8C9"
                />
              </svg>
            </span>
          </div>
          <div
            className={
              state.options
                ? "more--optionsItem is-visible"
                : "more--optionsItem"
            }
          >
            <span>Bring to front</span>
            <span>Send to back</span>
            <span onClick={onHandleToggle}>
              {isDraggable ? "Unlock" : "Lock"}
            </span>
            <span onClick={onHandledelete}>Delete file</span>
          </div>
        </div>
      </div>
      {state.bg.isActive && (
        <SketchPicker
          color={state.bg.color}
          onChangeComplete={handleChangeComplete}
        />
      )}
      {state.fill.isActive && (
        <SketchPicker
          color={state.fill.color}
          onChangeComplete={handleChangeFontColor}
        />
      )}
    </div>
  );
};

export default memo(Formatter);
